import React from 'react';

import AddedFilesDisplay from './AddedFilesDisplay';
import { AddFilesBtn, InsertFileIconButton } from './Button';
import { Divider, Icon, IconButton, List, ListItem, ListItemText, TextField } from '@material-ui/core';
import { Assignment, InsertDriveFile, NearMeSharp } from '@material-ui/icons';
import RoomDetailsDialog from './RoomDetailsDialog';
import { SuccessToast } from './Toast';
import { ClipTextField } from './TextField';
import BottomMainDeck from './BottomMainDeck';

const dragDrop = require('drag-drop');

class SenderDropArea extends React.Component {

    state = {
        isDragged : false,
        successToast : false,
    }

    componentDidMount(){


        dragDrop('#fileField',{
            onDrop: (files, pos, fileList, directories) => {
                this.props.getFile(fileList);
            },
            onDragEnter: ()=> {

                this.setState({
                    isDragged : true
                })

            },
            onDragLeave: ()=> {
                
                this.setState({
                    isDragged : false
                })
            }
        })
        


    }

    handleSendText = (txt) => {
        this.props.onSendClick(txt);
    }

    handleFiles = (file) => {
        this.props.getFile(file);
    }

    renderAddFiles = () => {

        return(
            <div className={this.props.fileList.length ? "topMainDeck": "noFilesTopMainDeck" } >
                { this.props.fileList.length ? <AddedFilesDisplay view={this.props.view} files={this.props.fileList} /> : null }
                <div className="addIconBtn" >
                    <InsertFileIconButton handleClick={this.handleFiles} />
                    <span className="fileName">
                        <AddFilesBtn view={this.props.view} disabled={this.props.disabled} handleClick={this.handleFiles} />  
                    </span>
                </div>
                { this.props.view === 'mobile' ? null : <div className="DropParatxt" > <p>or drop files to upload</p> </div> }
            </div>
        )

    }

    render(){

        const handleRender = () => {
            
            if (this.state.isDragged){
                return(
                    <React.Fragment>
                        <div className="DragEnterText" > 
                            <span className="dragEnterIcon" >
                                <Icon fontSize='large'>
                                    <NearMeSharp  className="dragEnterIcon" fontSize='large' />
                                </Icon>
                            </span>
                            <span>Drop file anywhere to send</span>
                        </div>
                    </React.Fragment>
                )
            }else {
                return(
                    <div className="dropArea" >  
                        { this.renderAddFiles() }
                        <div className="middleMainDeck" >
                            <Divider variant="middle" />
                        </div>
                        <BottomMainDeck />
                        {/* <RoomDetailsDialog analyzer={this.props.analyzer} view="mobile" copy={()=>{ this.setState({ successToast : true })}} show={this.props.openDetails} roomName={this.props.roomName} handleClose={ this.props.handleDetailClose } roomChanged={this.props.roomChanged}/> */}
                        <SuccessToast open={this.state.successToast} message="Copied to clipboard!" closeSnack={ ()=> { this.setState({ successToast : false }) } } />
                    </div>
                )
            }

        }

        return(
            <React.Fragment>
                {handleRender()}
            </React.Fragment>

        );
    }

}

export default SenderDropArea;